/*
  All fetch functions here accept a callback. The callback will more than likely
  end up being a setState call in the component it is called from.
*/

import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };


/*
@NotEmpty
@JsonProperty("username")
private String username;

@NotEmpty
@JsonProperty("password")
private String password;
*/
const loginRequest = (body, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/session/login',
    headers,
    body,
    successCallback,
    errorCallback,
  );
};

const logoutRequest = (successCallback, errorCallback) => {
  return UpdoxApi.postApiWithNoDataParam(
    '/api/session/logout',
    headers,
    successCallback,
    errorCallback,
  );
};

// @JsonProperty("code")
const verifyCode = (body, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/session/verification/code',
    headers,
    JSON.stringify(body),
    successCallback,
    errorCallback,
  );
};

// @NotEmpty
// @JsonProperty("dob")
const verifyDob = (body, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/session/verification/dob',
    headers,
    JSON.stringify(body),
    successCallback,
    errorCallback,
  );
};

// See /actions/preferences/preferencesAction for usage
const getAllPublicPreferences = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/public/practice-preferences',
    headers,
    successCallback,
    errorCallback,
  );
};

const SessionApi = {
  loginRequest,
  logoutRequest,
  verifyCode,
  verifyDob,
  getAllPublicPreferences,
};

export default SessionApi;



// WEBPACK FOOTER //
// ./src/apis/session.js